import { map } from 'rxjs/operators';

const deleteOne = (apiClient, localeCode, browseHomePageId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}/${browseHomePageId}`;

  return apiClient.delete(route).toPromise();
};

const duplicate = (apiClient, localeCode, browseHomePageId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}/${browseHomePageId}/duplicate`;

  return apiClient
    .post(route)
    .pipe(
      map(response => {
        return response.body;
      })
    )
    .toPromise();
};

const fetchAll = (apiClient, localeCode) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}`;

  return apiClient
    .get(route)
    .pipe(
      map(response => {
        const { metadata, results: browseHomePages = [] } = response.body;

        return {
          browseHomePages,
          metadata
        };
      })
    )
    .toPromise();
};

const fetchOne = (apiClient, localeCode, browseHomePageId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}/${browseHomePageId}`;

  return apiClient
    .get(route)
    .pipe(
      map(response => {
        return response.body;
      })
    )
    .toPromise();
};

const fetchPreview = (apiClient, localeCode, browseHomePageId) => {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/preview/${localeCode}/${browseHomePageId}`;

  return apiClient.get(route);
};

const saveMetadata = (apiClient, browseHomePageMetadata) => {
  const { localeCode } = browseHomePageMetadata;
  const route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}`;

  return apiClient
    .put(route, browseHomePageMetadata)
    .pipe(
      map(response => {
        return response.body;
      })
    )
    .toPromise();
};

const saveOne = (apiClient, localeCode, browseHomePage) => {
  const { browseHomePageId } = browseHomePage;

  const isNew = !browseHomePageId;
  const method = isNew ? 'post' : 'put';

  let route = apiClient.route`/libraries/${':librarySubdomain'}/admin/browse/home-pages/${localeCode}`;
  if (!isNew) {
    route = route.concat(`/${browseHomePageId}`);
  }

  return apiClient[method](route, browseHomePage)
    .pipe(
      map(response => {
        return response.body;
      })
    )
    .toPromise();
};

export { deleteOne, duplicate, fetchAll, fetchOne, fetchPreview, saveMetadata, saveOne };
